import React from 'react';
import { Link } from 'react-router-dom';
import { FaLink, FaExternalLinkAlt } from 'react-icons/fa';
import { toast } from 'sonner';

export function ShareProfileLink({ profileId, showOpen = true }) {
  const url = `${window.location.origin}/professionals/p/${profileId}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Profile link copied');
    } catch {
      toast.error('Could not copy — the link is ' + url);
    }
  };
  return (
    <div className="flex flex-wrap gap-3 mb-6 text-sm">
      <button onClick={copy} className="inline-flex items-center text-blue-600 hover:underline" data-testid="copy-profile-link-btn">
        <FaLink className="mr-1" />Copy profile link
      </button>
      {showOpen && (
        <Link to={`/professionals/p/${profileId}`} className="inline-flex items-center text-blue-600 hover:underline" data-testid="open-profile-page-link">
          <FaExternalLinkAlt className="mr-1" />Open full page
        </Link>
      )}
    </div>
  );
}
